/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const CreateTransmittalDocumentInputDto = zod.object({
  "id": zod.string().uuid().nullish(),
  "transmittalRecordId": zod.string().uuid().optional()
});

export type CreateTransmittalDocumentInputDto = zod.input<typeof CreateTransmittalDocumentInputDto>;
export type CreateTransmittalDocumentInputDtoOutput = zod.output<typeof CreateTransmittalDocumentInputDto>;
